import Stage from './Stage.json';
import Task from './Task.json';

export default {
  Stage,
  Task,
};
